import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'

interface DraftSeoCardProps {
  seo: {
    title: string
    description: string
    keywords: string[]
  }
}

export function DraftSeoCard({ seo }: DraftSeoCardProps) {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Card>
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        <CardHeader className="pb-3">
          <CollapsibleTrigger className="flex items-center justify-between w-full">
            <CardTitle className="text-sm font-medium">SEO Metadata</CardTitle>
            <ChevronDown
              className={`w-4 h-4 text-muted-foreground transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          </CollapsibleTrigger>
        </CardHeader>
        <CollapsibleContent>
          <CardContent className="pt-0 space-y-3">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Title</p>
              <p className="text-sm">{seo?.title || '\u2014'}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Description</p>
              <p className="text-sm">{seo?.description || '\u2014'}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Keywords</p>
              {(seo?.keywords?.length ?? 0) > 0 ? (
                <div className="flex flex-wrap gap-1" role="list">
                  {seo.keywords.map((kw) => (
                    <Badge key={kw} variant="secondary" className="text-xs" role="listitem">
                      {kw}
                    </Badge>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground">{'\u2014'}</p>
              )}
            </div>
          </CardContent>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  )
}
